const MECHANIC_WALLET = "/mechanicWallet";

export const GET_MECHANIC_WALLET_TRANSACTIONS = `${MECHANIC_WALLET}/mechanicWalletTransactions`;
